import i18n from "../i18n";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, ArrowLeft, Mail } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");
        try {
            const { data } = await api.post("/auth/forgot-password", { email });
            setMessage(data.message);
        } catch (requestError) {
            setError(formatApiErrorDetail(requestError.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="min-h-screen bg-[#0f1f16] text-white grid place-items-center px-4 py-10">
            <section className="w-full max-w-md rounded-3xl border border-white/10 bg-white/5 p-7 sm:p-10 shadow-2xl" data-testid="forgot-password-card">
                <div className="w-14 h-14 rounded-2xl bg-primary grid place-items-center mb-6"><Sprout className="w-7 h-7" /></div>
                <p className="tiny-label text-primary/80">{i18n.t("final.a73c0b6b0574")}</p>
                <h1 className="text-3xl font-bold mt-2">{i18n.t("final.a2f060b7363f")}</h1>
                <p className="text-sm text-white/60 mt-3">{i18n.t("final.292f708ce44c")}</p>
                <form onSubmit={submit} className="mt-8 space-y-5">
                    <div>
                        <Label htmlFor="recovery-email" className="tiny-label text-white/70">{i18n.t("final.84add5b29527")}</Label>
                        <Input id="recovery-email" type="email" required value={email} onChange={(event) => setEmail(event.target.value)} data-testid="password-recovery-email-input" className="h-13 mt-2 bg-white/5 border-white/15 text-white" />
                    </div>
                    {message && <div data-testid="password-recovery-request-message" role="status" className="text-sm text-emerald-200 bg-emerald-500/10 border border-emerald-400/20 rounded-xl p-4">{message}</div>}
                    {error && <div role="alert" className="text-sm text-red-300 bg-red-500/10 border border-red-400/20 rounded-xl p-4">{error}</div>}
                    <Button type="submit" disabled={loading} data-testid="password-recovery-request-button" className="w-full h-13 rounded-2xl"><Mail className="w-4 h-4 mr-2" />{loading ? "Sending…" : "Send reset link"}</Button>
                </form>
                <Link to="/login" className="mt-7 inline-flex items-center text-sm text-primary font-semibold"><ArrowLeft className="w-4 h-4 mr-2" />{i18n.t("final.4da821676b2f")}</Link>
            </section>
        </main>
    );
}
